import React, { Component } from 'react';
import SERVER_URL from '../Global';
import { Affix, Breadcrumb, Icon, Spin, Button, Popover, Checkbox } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import { Select, Input, Avatar } from 'antd';
import { HrCardDetail } from './HrCardDetail';

const { Option } = Select;

export class HrList extends Component {
    static displayName = HrList.name;

    constructor(props) {
        super(props);

        this.state = {
            hrss: [],
            loading: true,
            top: 10,
            orderBy: 'surname',
            order: 1,
            searchName: '',
            detailHr: [],
            loadingDetail: true,
            editedName: '',
            editedSurname: '',
            portraitImage: '',
            contacts: [],
            companyId: '',
            iniziale: 'A',
            alfabeto: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '#'],
            user: this.props.token,
            detailHrBridge: [],
            isItABridge: false,
            loadingComp: true,
            company: [],
            loadingXML: false,
            inDesignXML: '',
            roleName: '',
            hasFiltersOn: false,
            pageNumber: 1,
            loadingBelow: false,
            categories: [],
            categoryName: '',
            catId: '',
            activeHr: false
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.editName = this.editName.bind(this);
        this.editSurname = this.editSurname.bind(this);
        this.getDetailBridge = this.getDetailBridge.bind(this);
        this.exportInDesign = this.exportInDesign.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.hrReload = this.hrReload.bind(this);
        this.handleFilters = this.handleFilters.bind(this);
        this.handleRoleName = this.handleRoleName.bind(this);
        this.infiniteScroll = this.infiniteScroll.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.handleCat = this.handleCat.bind(this);
        this.hrDelete = this.hrDelete.bind(this);

        document.title = "Polar - People"

        fetch(
            `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": this.state.searchName,
                    "page": 1,
                    "pageSize": 60,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": this.state.orderBy,
                        "order": this.state.order
                    },
                    "Status": 1
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ hrss: res.data, loading: false, maxPageSize: res.params.totalPages });

                    if (this.state.order === undefined) {
                        this.setState({ order: '1' });
                    }

                    if (this.state.orderBy === undefined) {
                        this.setState({ orderBy: ' ' });
                    }

                    if (this.state.searchName === undefined) {
                        this.setState({ searchName: ' ' });
                    }
                } else {
                    this.setState({ hrss: [], loading: false });
                } 
            })

        //categorie
        fetch(
            `${SERVER_URL + 'api/companycategory/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": '',
                    "page": 1,
                    "PageSize": 88,
                    "ordering": {
                        "orderPropertyName": 'catId',
                        "order": 1
                    }
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    let categories = []

                    res.data.sort(function (a, b) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    }).map(cat => {
                        if (cat.companyCategoryParentCatId == null) {
                            categories.push(cat)
                            res.data.map(son => {
                                if (son.companyCategoryParentCatId === cat.catId) {
                                    categories.push(son)
                                }
                                return 0;
                            })
                        }
                        return 0;
                    })

                    this.setState({ categories: categories });
                } else {
                    this.setState({ categories: [] });
                }
            })
    };

    handleCat(value) {
        if (value > 0) {
            let catName = this.state.categories.find(x => x.catId == value).name;

            this.setState({ catId: [value], categoryName: catName })
        } else {
            this.setState({ catId: '', categoryName: '' })
        }
    }

    exportInDesign() {
        this.setState({ loadingXML: true });

        fetch(
            `${SERVER_URL + 'api/export/hrIndex?lang=en&categoryName=' + this.state.categoryName + "&roleName=" + this.state.roleName}`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                }, 
                body: JSON.stringify({

                })
            }
        ).then(response => response.text())
            .then(response => {
                this.setState({ inDesignXML: response, loadingXML: false });
            })
    }

    hrReload(orderBy, order) {
        this.setState({ loading: true });
        fetch(
            `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "NameSurname": this.state.searchName,
                    "page": 1,
                    "pageSize": 60,
                    "pageSizeOptions": null,
                    "companyCatIdList": this.state.catId,
                    "ordering": {
                        "orderPropertyName": orderBy,
                        "order": order
                    },
                    "Status": 1,
                    "role": this.state.roleName,
                    "HasActiveRole": this.state.activeHr
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ hrss: res.data, loading: false, order: order, orderBy: orderBy, maxPageSize: res.params.totalPages, inDesignXML: '' });
                } else {
                    this.setState({ hrss: [], loading: false, inDesignXML: '' });
                }
        })
    }

    clearFilters() {
        this.setState({ roleName: '', categoryName: '', catId: '' }, this.handleFilters)
    }

    infiniteScroll(e) {
        let hrss = this.state.hrss;
        var fondo = e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 3;
        if (fondo && this.state.maxPageSize > this.state.pageNumber) {
            let newPage = this.state.pageNumber + 1
            this.setState({ loadingBelow: true });
            fetch(
                `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "name": this.state.searchName,
                        "page": newPage,
                        "pageSize": 60,
                        "companyCatIdList": this.state.catId,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": this.state.orderBy,
                            "order": this.state.order
                        },
                        "Status": 1,
                        "role": this.state.roleName,
                        "HasActiveRole": this.state.activeHr
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ hrss: hrss.concat(res.data), pageNumber: newPage, loadingBelow: false, inDesignXML: '' });
                    } else {
                        this.setState({ hrss: hrss, pageNumber: newPage, loadingBelow: false, inDesignXML: '' });
                    }
            })
        }
    }

    handleRoleName(event) {
        this.setState({ roleName: event.target.value });
    }

    handleFilters() {
        if (this.state.roleName !== '' || this.state.categoryName !== '' || this.state.activeHr) {
            this.setState({ hasFiltersOn: true }, () => { this.hrReload(this.state.orderBy, this.state.order) })
        }
        else {
            this.setState({ hasFiltersOn: false }, () => { this.hrReload(this.state.orderBy, this.state.order) })
        }
    }

    copyToClipboard() {

        var date = new Date().getDate(); //Current Date
        var month = new Date().getMonth() + 1; //Current Month
        var year = new Date().getFullYear(); //Current Year
        var hours = new Date().getHours(); //Current Hours
        var min = new Date().getMinutes(); //Current Minutes

        var oggi = year + '' + month + '' + date + '_' + hours + '' + min

        const element = document.createElement("a");
        const file = new Blob([this.state.inDesignXML], { type: 'application/xhtml+xml' });
        element.href = URL.createObjectURL(file);
        element.download = "Polar_export_Indice_People_" + oggi + ".xml";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }

    DeleteJson(hrId) {
        fetch(`${SERVER_URL + 'api/hr/' + hrId + '/true'}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`
            },
        });
    }

    getDetail(hrId) {
        fetch(`${SERVER_URL + 'api/hr/' + hrId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`
            }
        }).then(response => response.json())
            .then(res => {
                this.setState({ detailHr: res.data, loadingDetail: false, isItABridge: true, loadingComp: true });

                if (res.data.officeDto != null) {
                    this.setState({ company: res.data.officeDto.company, loadingComp: false });
                }
                else {
                    if (res.data.brHrRoleOfficies.length > 0) {
                        this.setState({ company: res.data.brHrRoleOfficies[0].office.company, loadingComp: false });
                    } else {
                        this.setState({ company: null, loadingComp: false });
                    }
                }
            }
        )
    }

    getDetailBridge(hrId) {
        fetch(`${SERVER_URL + 'api/hr/' + hrId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`
            },
        }).then(response => response.json())
            .then(res => {
                this.setState({ detailHrBridge: res.data, loadingDetail: false, isItABridge: true });
            });
    }

    getFiles(files) {
        this.setState({ portraitImage: files.base64 })
    }

    handleNameChange(event) {
        this.setState({ searchName: event.target.value})
        if (event.target.value.length > 2 || event.target.value.length === 0) {
            this.setState({ loading: true });
            fetch(
                `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "NameSurname": event.target.value,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "companyCatIdList": this.state.catId,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": this.state.orderBy,
                            "order": this.state.order
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0,
                        "HasActiveRole": this.state.activeHr
                    })
                }
            ).then(response => response.json())
                .then(res => {
                if (res.data != null) {
                    this.setState({ hrss: res.data, loading: false, maxPageSize: res.params.totalPages, inDesignXML: '' });
                }
                else {
                    this.setState({ loading: false, hrss: [], maxPageSize: 0, inDesignXML: '' });
                }
            })
        }
    }

    editName(event) {
        this.setState({ editedName: event.target.value });
    }

    editSurname(event) {
        this.setState({ editedSurname: event.target.value });
    }

    closeDetail() {
        this.setState({ loadingDetail: true });
    }

    hrDelete() {
        fetch(
            `${SERVER_URL + 'api/hr/hard/' + this.state.detailHr.hrId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                }
            }
        ).then(() => {
            fetch(
                `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "NameSurname": this.state.searchName,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "companyCatIdList": this.state.catId,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": this.state.orderBy,
                            "order": this.state.order
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0,
                        "HasActiveRole": this.state.activeHr
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ hrss: res.data, loading: false, loadingComp: true, maxPageSize: res.params.totalPages });
                    }
                    else {
                        this.setState({ loading: false, hrss: [], loadingComp: true });
                    }
                })
        })
    }


    render() {

        let contentsDetail = this.state.loadingComp ? '' : <HrCardDetail hr={this.state.detailHr} delete={this.hrDelete} comp={this.state.company} />;

        let listaCat = this.state.categories.map(cat => {
            if (cat.companyCategoryParentCatId == null) {
                return <Option key={cat.catId}>{cat.name}</Option>
            } else {
                return <Option key={cat.catId}>-{cat.name}</Option>
            }
        })

        let filtri =
            <div>
                <div className="filterGroup">

                    <div>

                        <div style={{ display: 'block', width: '100%' }}>

                            <p>Role Name</p>
                        </div>
                        <div style={{ display: 'block', width: '100%' }}>
                            <Input autoComplete="new-password" value={this.state.roleName} style={{ display: 'block', margin: '0px 0px 0px auto' }} placeholder="Start typing to filter through roles" allowClear={true} onChange={this.handleRoleName} />
                        </div>
                    </div>

                </div>

                <hr />

                <div>
                    <div style={{ display: 'block', width: '100%' }}>
                        <p>Filter Categories</p>
                    </div>

                    <div style={{ display: 'block', width: '100%' }}>
                        <Select
                            mode="single"
                            className={'selectWizard darkSelect handleTyp'}
                            placeholder="Typology"
                            style={{ width: '100%', fontWeight: '500' }}
                            onChange={this.handleCat}
                            allowClear={true}
                            value={this.state.categoryName}
                        >
                            {listaCat}
                        </Select>

                        <p className="mt-3">Filter active role</p>

                        <div style={{ display: 'block', width: '100%' }}>
                            <Checkbox
                                disabled={false}
                                onChange={(e) => this.setState({ activeHr: e.target.checked })}
                                checked={this.state.activeHr}
                            >
                                Show only with active roles
                            </Checkbox>
                        </div>
                    </div>
                    <br /><br />
                </div>

                <Button onClick={this.handleFilters} style={{ marginLeft: '16px', marginBottom: '10px' }}>Apply</Button>

                <Button onClick={this.clearFilters} style={{ marginLeft: '16px', marginBottom: '10px' }}>Clear Filters</Button>
            </div>

        let inDesign = this.state.inDesignXML !== '' ? <Button onClick={this.copyToClipboard}>Download File</Button> : <Button onClick={this.exportInDesign} style={{ marginLeft: '6px' }} size="default">Export Hr's Index</Button>

        let exportWait = this.state.loadingXML ? <Spin style={{ marginLeft: '20px' }} indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} /> : ''

        let popoverExport =
            <div>
                {inDesign}
                {exportWait}
            </div>

        let tableContent = this.state.loading ?
            <tr className="spinContainer">
                <td>
                    <Icon type="loading" style={{ fontSize: 114, color: '#1890ff' }} spin />
                </td>
            </tr> :
                this.state.hrss.map(hr => {
                    return (
                        <tr key={hr.hrId}>
                            <td onClick={() => this.getDetail(hr.hrId)}>{hr.surname}</td>
                            <td onClick={() => this.getDetail(hr.hrId)}>{hr.name}</td>
                            <td className="categoryNameList" onClick={() => this.getDetail(hr.hrId)}>{hr.brHrRoleOfficies.map(br => {
                                if (br.role != null) {
                                    return <span key={br.roleId}>{br.role.name}</span>
                                } else {
                                    return 0;
                                }
                            })}
                            </td>
                            <td className="categoryNameList" onClick={() => this.getDetail(hr.hrId)}>{hr.brHrRoleOfficies.map(br => {
                                if (br.office != null) {
                                    if (br.office.company != null) {
                                        return <span key={br.hroId}>{br.office.company.name}</span>
                                    } else {
                                        return 0;
                                    }
                                } else {
                                    return 0;
                                }
                            })}
                            </td>
                        </tr>
                    )
                })

        let infiniteScroll = this.state.loadingBelow ? <Spin className="preloaderBelow" indicator={<Icon type="loading" style={{ fontSize: 114 }} spin />} /> : ''

        let noHr = this.state.hrss.length === 0 ?
            <div className="noHr">
                <h3>No HR found</h3>
            </div> : ''

        return (
            <Container fluid={true}>
                <Row>
                    <Col sm="12" style={{ display:'inline-flex', height: '0' }}>
                        <Breadcrumb className="bread">                            
                            <Breadcrumb.Item>People</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="plusButtonCat">
                            <a style={{ marginRight: '10px' }} className="button create" href="/hr/create" ><Icon type="plus" /></a>
                        </div>
                        <div className="ant-breadcrumb searchList cat midSearchBar">
                            <Input autoComplete="new-password" placeholder="Search People" style={{ width: '100%', marginTop: '-1em' }} allowClear={true} value={this.state.searchName} onChange={this.handleNameChange} />
                            <Icon className="homeViewSearch" onClick={this.handleFilters} type="search" />
                        </div>

                        <div className="ant-breadcrumb searchList filterButtons">
                            <div className="homeFilersButtonsContainer">
                                <Popover placement="bottomRight" title={<p>Advanced filters</p>} content={filtri} trigger="click">
                                    <Avatar className={"filterButton filterson" + this.state.hasFiltersOn} icon="filter" />
                                </Popover>

                                <Popover placement="bottom" title={<p style={{ textAlign:'center' }}>Export Results</p>} content={popoverExport} trigger="click">
                                    <Button className="exportButton" type="primary" shape="round" icon="download" size="default">
                                        Export
                                    </Button>
                                </Popover>
                            </div>
                        </div>
                    </Col>
                    
                    <Col sm="9" onScroll={this.infiniteScroll} className="mainBoard">

                        <div className="tableContainer">
                            <table className='table table-striped'>
                                <thead>
                                    <tr>
                                        <th style={{ width: '15%' }}><p style={{ whiteSpace: "nowrap", marginBottom: '0' }}>Surname <Icon type="down" onClick={() => this.hrReload("surname", 1)} /><Icon type="up" onClick={() => this.hrReload("surname", -1)} /></p></th>
                                        <th style={{ width: '15%' }}><p style={{ whiteSpace: "nowrap", marginBottom: '0' }}>Name <Icon type="down" onClick={() => this.hrReload("name", 1)} /><Icon type="up" onClick={() => this.hrReload("name", -1)} /></p></th>
                                        <th style={{ width: '35%' }}>Role</th>
                                        <th style={{ width: '35%' }}>Company, Brand, Sign or Department</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableContent}
                                </tbody>
                            </table>
                            {infiniteScroll}
                        </div>
                        {noHr}

                    </Col>
                    <Col sm="3">
                        <Affix offsetTop={this.state.top}>
                            <div className="inner hrCard">
                                {contentsDetail}
                            </div>
                        </Affix>
                    </Col>
                </Row>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Hr/HrIndexGET.js